import { render, staticRenderFns } from "./StoreSidebar.vue?vue&type=template&id=1214a020&scoped=true"
import script from "./StoreSidebar.vue?vue&type=script&lang=js"
export * from "./StoreSidebar.vue?vue&type=script&lang=js"
import style0 from "./StoreSidebar.vue?vue&type=style&index=0&id=1214a020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214a020",
  null
  
)

export default component.exports